import { render, staticRenderFns } from "./Reqrefund.vue?vue&type=template&id=1d5011ca&scoped=true"
import script from "./Reqrefund.vue?vue&type=script&lang=js"
export * from "./Reqrefund.vue?vue&type=script&lang=js"
import style0 from "./Reqrefund.vue?vue&type=style&index=0&id=1d5011ca&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5011ca",
  null
  
)

export default component.exports